export class SmoothDeslocationHelper {
    static async goToPostitionFromTop(offsetTop, miliseconds) {
        const timeBetweenIterations = 10;
        const deslocationBetweenIterations = offsetTop / (miliseconds / timeBetweenIterations);
        
        let offset = deslocationBetweenIterations;
        do {
            await new Promise(resolve => setTimeout(resolve, timeBetweenIterations));
            window.scrollTo(0, offset);

            offset += deslocationBetweenIterations;
        } while(offsetTop > offset);
    }
}
